/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: frLTK57AGre4oWC8c14hh8
// Component: xCQTqgRPSEzy

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { LGPresetMessage } from "@lg-plus/landing-components"; // plasmic-import: Y_XJixG3jqCi/codeComponent
import { LGCTAButton } from "@lg-plus/landing-components"; // plasmic-import: 0RjRSxRvndVB/codeComponent
import ButtonPrimary from "../../ButtonPrimary"; // plasmic-import: gBcYwlRN_sbt/component
import Slider from "../../Slider"; // plasmic-import: qrFGWHW4aFvm/component
import SliderThumb from "../../SliderThumb"; // plasmic-import: fzVvinIE-R4c/component
import WhyRerum from "../../WhyRerum"; // plasmic-import: LCH5wX9ZcSAe/component
import Card from "../../Card"; // plasmic-import: FAl17XXW_Z4E/component
import CarouselBtn from "../../CarouselBtn"; // plasmic-import: ATFJz5kNDFpA/component
import { SliderWrapper } from "@plasmicpkgs/react-slick";
import { sliderHelpers as SliderWrapper_Helpers } from "@plasmicpkgs/react-slick";
import ReviewCard from "../../ReviewCard"; // plasmic-import: yjO6g1VOwtWV/component
import FaqItem from "../../FaqItem"; // plasmic-import: z_EEY0ZbKelr/component
import FooterSection from "../../FooterSection"; // plasmic-import: VmHDhDPiJD3u/component
import { Fetcher } from "@plasmicapp/react-web/lib/data-sources";
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: frLTK57AGre4oWC8c14hh8/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: frLTK57AGre4oWC8c14hh8/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicHomepage.module.css"; // plasmic-import: xCQTqgRPSEzy/css

import Logo1Svg2Icon from "./icons/PlasmicIcon__Logo1Svg2"; // plasmic-import: DK0vbTeKcBpQ/icon
import MenuButtonSvgIcon from "./icons/PlasmicIcon__MenuButtonSvg"; // plasmic-import: 2m14IX15gRNQ/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: rsxhuEhqWOuH/icon
import CircleIcon from "./icons/PlasmicIcon__Circle"; // plasmic-import: 9sHJQRmA0elH/icon
import ChevronDownIcon from "./icons/PlasmicIcon__ChevronDown"; // plasmic-import: BcA8RyhY-uEx/icon

const emptyProxy: any = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q: any): any {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export type PageCtx = {
  pageRoute: string;
  pagePath: string;
  params: Record<string, string | string[] | undefined>;
  query: Record<string, string | string[] | undefined>;
};

export function generateDynamicMetadata($q: any, $ctx: PageCtx) {
  return {
    title: "Hlavní stránka - podat žádost o půjčku",

    openGraph: {
      title: "Hlavní stránka - podat žádost o půjčku"
    },
    twitter: {
      card: "summary" as const,
      title: "Hlavní stránka - podat žádost o půjčku"
    }
  };
}

createPlasmicElementProxy;

export type PlasmicHomepage__VariantMembers = {};
export type PlasmicHomepage__VariantsArgs = {};
type VariantPropType = keyof PlasmicHomepage__VariantsArgs;
export const PlasmicHomepage__VariantProps = new Array<VariantPropType>();

export type PlasmicHomepage__ArgsType = {};
type ArgPropType = keyof PlasmicHomepage__ArgsType;
export const PlasmicHomepage__ArgProps = new Array<ArgPropType>();

export type PlasmicHomepage__OverridesType = {
  homePageWrapper?: Flex__<"div">;
  lgPresetMessage?: Flex__<typeof LGPresetMessage>;
  headerHeroSection?: Flex__<"div">;
  menuButton?: Flex__<"button">;
  menuCloseButton?: Flex__<"button">;
  crossSvg?: Flex__<"svg">;
  mobileMenu?: Flex__<"div">;
  pageWrapper?: Flex__<"div">;
  slider?: Flex__<typeof Slider>;
  whyRerum?: Flex__<"div">;
  procRerum?: Flex__<"div">;
  h3?: Flex__<"h3">;
  reviewsSection?: Flex__<"div">;
  sliderCarousel?: Flex__<typeof SliderWrapper>;
  faq?: Flex__<"section">;
  h4?: Flex__<"h4">;
  slider2?: Flex__<typeof Slider>;
  footerSection?: Flex__<typeof FooterSection>;
};

export interface DefaultHomepageProps {}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHomepage__RenderFunc(props: {
  variants: PlasmicHomepage__VariantsArgs;
  args: PlasmicHomepage__ArgsType;
  overrides: PlasmicHomepage__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "slider.value",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          (() => {
            try {
              return $state.amount;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return 17000;
              }
              throw e;
            }
          })()
      },
      {
        path: "slider2.value",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          (() => {
            try {
              return $state.amount;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return 17000;
              }
              throw e;
            }
          })()
      },
      {
        path: "amount",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 17000
      },
      {
        path: "menuSwitch",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "sliderCarousel.currentSlide",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 0,

        refName: "sliderCarousel",
        onMutate: generateOnMutateForSpec("currentSlide", SliderWrapper_Helpers)
      }
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const pageMetadata = generateDynamicMetadata(
    wrapQueriesWithLoadingProxy({}),
    $ctx as PageCtx
  );

  const styleTokensClassNames = _useStyleTokens();

  return (
    <React.Fragment>
      <Head>
        <meta name="twitter:card" content="summary" />
        <title key="title">{pageMetadata.title}</title>
        <meta key="og:title" property="og:title" content={pageMetadata.title} />
        <meta
          key="twitter:title"
          property="twitter:title"
          content={pageMetadata.title}
        />
      </Head>

      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={"plasmic_page_wrapper"}>
        <div
          data-plasmic-name={"homePageWrapper"}
          data-plasmic-override={overrides.homePageWrapper}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            "all",
            "root_reset_frLTK57AGre4oWC8c14hh8",
            "plasmic_default_styles",
            "plasmic_mixins",
            styleTokensClassNames,
            sty.homePageWrapper
          )}
        >
          <LGPresetMessage
            data-plasmic-name={"lgPresetMessage"}
            data-plasmic-override={overrides.lgPresetMessage}
            className={classNames("__wab_instance", sty.lgPresetMessage)}
            content={
              "Tento odkaz je neplatn\u00fd nebo jeho platnost vypr\u0161ela."
            }
            isDynamic={true}
            preset={"INVALID_LINK"}
          />

          <div
            data-plasmic-name={"headerHeroSection"}
            data-plasmic-override={overrides.headerHeroSection}
            className={classNames("all", sty.headerHeroSection)}
          >
            <div className={classNames("all", sty.freeBox__q1Fqe)}>
              <Logo1Svg2Icon
                className={classNames("all", sty.svg___3E544)}
                role={"img"}
              />

              <button
                data-plasmic-name={"menuButton"}
                data-plasmic-override={overrides.menuButton}
                className={classNames(
                  "all",
                  "button",
                  "button__frLTK",
                  sty.menuButton
                )}
                onClick={async event => {
                  const $steps = {};

                  $steps["updateMenuSwitch"] = true
                    ? (() => {
                        const actionArgs = {
                          variable: {
                            objRoot: $state,
                            variablePath: ["menuSwitch"]
                          },
                          operation: 0,
                          value: true
                        };
                        return (({
                          variable,
                          value,
                          startIndex,
                          deleteCount
                        }) => {
                          if (!variable) {
                            return;
                          }
                          const { objRoot, variablePath } = variable;

                          $stateSet(objRoot, variablePath, value);
                          return value;
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["updateMenuSwitch"] != null &&
                    typeof $steps["updateMenuSwitch"] === "object" &&
                    typeof $steps["updateMenuSwitch"].then === "function"
                  ) {
                    $steps["updateMenuSwitch"] =
                      await $steps["updateMenuSwitch"];
                  }
                }}
                ref={ref => {
                  $refs["menuButton"] = ref;
                }}
              >
                {(
                  hasVariant(globalVariants, "screen", "mobileOnly")
                    ? (() => {
                        try {
                          return !$state.menuSwitch;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return true;
                          }
                          throw e;
                        }
                      })()
                    : true
                ) ? (
                  <MenuButtonSvgIcon
                    className={classNames("all", sty.svg__ie83C)}
                    role={"img"}
                  />
                ) : null}
              </button>
              {(() => {
                try {
                  return $state.menuSwitch;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return true;
                  }
                  throw e;
                }
              })() ? (
                <button
                  data-plasmic-name={"menuCloseButton"}
                  data-plasmic-override={overrides.menuCloseButton}
                  className={classNames(
                    "all",
                    "button",
                    "button__frLTK",
                    sty.menuCloseButton
                  )}
                  onClick={async event => {
                    const $steps = {};

                    $steps["updateMenuSwitch"] = true
                      ? (() => {
                          const actionArgs = {
                            variable: {
                              objRoot: $state,
                              variablePath: ["menuSwitch"]
                            },
                            operation: 0,
                            value: false
                          };
                          return (({
                            variable,
                            value,
                            startIndex,
                            deleteCount
                          }) => {
                            if (!variable) {
                              return;
                            }
                            const { objRoot, variablePath } = variable;

                            $stateSet(objRoot, variablePath, value);
                            return value;
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["updateMenuSwitch"] != null &&
                      typeof $steps["updateMenuSwitch"] === "object" &&
                      typeof $steps["updateMenuSwitch"].then === "function"
                    ) {
                      $steps["updateMenuSwitch"] =
                        await $steps["updateMenuSwitch"];
                    }
                  }}
                  ref={ref => {
                    $refs["menuCloseButton"] = ref;
                  }}
                >
                  <IconIcon
                    data-plasmic-name={"crossSvg"}
                    data-plasmic-override={overrides.crossSvg}
                    className={classNames("all", sty.crossSvg)}
                    role={"img"}
                  />
                </button>
              ) : null}
              <div className={classNames("all", sty.freeBox__kwbI6)}>
                <PlasmicLink__
                  className={classNames(
                    "all",
                    "a",
                    "a__frLTK",
                    "__wab_text",
                    sty.link___0Xupe
                  )}
                  component={Link}
                  href={"#opujcce"}
                  legacyBehavior={false}
                  platform={"nextjs"}
                >
                  {"O p\u016fj\u010dce"}
                </PlasmicLink__>
                <PlasmicLink__
                  className={classNames(
                    "all",
                    "a",
                    "a__frLTK",
                    "__wab_text",
                    sty.link__j06GV
                  )}
                  component={Link}
                  href={"#recenze"}
                  legacyBehavior={false}
                  platform={"nextjs"}
                >
                  {"Recenze"}
                </PlasmicLink__>
                <PlasmicLink__
                  className={classNames(
                    "all",
                    "a",
                    "a__frLTK",
                    "__wab_text",
                    sty.link__og3Dt
                  )}
                  component={Link}
                  href={"#faq"}
                  legacyBehavior={false}
                  platform={"nextjs"}
                >
                  {"Ot\u00e1zky a odpov\u011bdi"}
                </PlasmicLink__>
                <LGCTAButton
                  amount={$state.amount}
                  buttonSlot={
                    <ButtonPrimary
                      className={classNames(
                        "__wab_instance",
                        sty.buttonPrimary___69VqU
                      )}
                      label={
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__pocTp
                          )}
                        >
                          {"Z\u00edskat pen\u00edze"}
                        </div>
                      }
                    />
                  }
                  className={classNames(
                    "__wab_instance",
                    sty.lgctaButton___262En
                  )}
                  id={"cta-btn-2"}
                />
              </div>
            </div>
          </div>
          {(
            hasVariant(globalVariants, "screen", "mobileOnly")
              ? (() => {
                  try {
                    return $state.menuSwitch;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return true;
                    }
                    throw e;
                  }
                })()
              : true
          ) ? (
            <div
              data-plasmic-name={"mobileMenu"}
              data-plasmic-override={overrides.mobileMenu}
              className={classNames("all", sty.mobileMenu)}
              onClick={async event => {
                const $steps = {};

                $steps["updateMenuSwitch"] = true
                  ? (() => {
                      const actionArgs = {
                        variable: {
                          objRoot: $state,
                          variablePath: ["menuSwitch"]
                        },
                        operation: 0,
                        value: false
                      };
                      return (({
                        variable,
                        value,
                        startIndex,
                        deleteCount
                      }) => {
                        if (!variable) {
                          return;
                        }
                        const { objRoot, variablePath } = variable;

                        $stateSet(objRoot, variablePath, value);
                        return value;
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["updateMenuSwitch"] != null &&
                  typeof $steps["updateMenuSwitch"] === "object" &&
                  typeof $steps["updateMenuSwitch"].then === "function"
                ) {
                  $steps["updateMenuSwitch"] = await $steps["updateMenuSwitch"];
                }
              }}
            >
              <PlasmicLink__
                className={classNames(
                  "all",
                  "a",
                  "a__frLTK",
                  "__wab_text",
                  sty.link___9PgcJ
                )}
                component={Link}
                href={"#opujcce"}
                legacyBehavior={false}
                platform={"nextjs"}
              >
                {"O p\u016fj\u010dce"}
              </PlasmicLink__>
              <PlasmicLink__
                className={classNames(
                  "all",
                  "a",
                  "a__frLTK",
                  "__wab_text",
                  sty.link__wqIu6
                )}
                component={Link}
                href={"#recenze"}
                legacyBehavior={false}
                platform={"nextjs"}
              >
                {"Recenze"}
              </PlasmicLink__>
              <PlasmicLink__
                className={classNames(
                  "all",
                  "a",
                  "a__frLTK",
                  "__wab_text",
                  sty.link__n50Rb
                )}
                component={Link}
                href={"#faq"}
                legacyBehavior={false}
                platform={"nextjs"}
              >
                {"Ot\u00e1zky a odpov\u011bdi"}
              </PlasmicLink__>
            </div>
          ) : null}
          <div
            data-plasmic-name={"pageWrapper"}
            data-plasmic-override={overrides.pageWrapper}
            className={classNames("all", sty.pageWrapper)}
          >
            <h1
              className={classNames(
                "all",
                "h1",
                "h1__frLTK",
                "__wab_text",
                sty.h1___5W7Dd
              )}
            >
              {"Nebankovn\u00ed p\u016fj\u010dka Rerum"}
            </h1>
            <div className={classNames("all", sty.freeBox__uliO)}>
              <div className={classNames("all", "__wab_text", sty.text___0MXX)}>
                {
                  "Vypl\u0148te online \u017e\u00e1dost a do 15 minut m\u016f\u017eete m\u00edt pen\u00edze na \u00fa\u010dtu.\nIde\u00e1ln\u00ed \u0159e\u0161en\u00ed, kdy\u017e pot\u0159ebujete finance rychle a bez zbyte\u010dn\u00e9ho \u010dek\u00e1n\u00ed."
                }
              </div>
            </div>
            <div className={classNames("all", sty.freeBox__u5XlR)}>
              <h1
                className={classNames(
                  "all",
                  "h1",
                  "h1__frLTK",
                  "__wab_text",
                  sty.h1__q4YVb
                )}
              >
                {hasVariant(globalVariants, "screen", "mobileOnly")
                  ? "Za\u010dn\u011bte v\u00fdb\u011brem \u010d\u00e1stky"
                  : "Za\u010dn\u011bte v\u00fdb\u011brem \u010d\u00e1stky"}
              </h1>
              <div className={classNames("all", sty.freeBox__knyOw)}>
                <Slider
                  data-plasmic-name={"slider"}
                  data-plasmic-override={overrides.slider}
                  className={classNames("__wab_instance", sty.slider)}
                  label={
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__v7GAp
                      )}
                    >
                      {"Kolik si chcete p\u016fj\u010dit?"}
                    </div>
                  }
                  onChange={async (...eventArgs: any) => {
                    generateStateOnChangeProp($state, [
                      "slider",
                      "value"
                    ]).apply(null, eventArgs);

                    if (
                      eventArgs.length > 1 &&
                      eventArgs[1] &&
                      eventArgs[1]._plasmic_state_init_
                    ) {
                      return;
                    }

                    (async val => {
                      const $steps = {};

                      $steps["updateAmount"] = true
                        ? (() => {
                            const actionArgs = {
                              variable: {
                                objRoot: $state,
                                variablePath: ["amount"]
                              },
                              operation: 0,
                              value: $state.slider.value
                            };
                            return (({
                              variable,
                              value,
                              startIndex,
                              deleteCount
                            }) => {
                              if (!variable) {
                                return;
                              }
                              const { objRoot, variablePath } = variable;

                              $stateSet(objRoot, variablePath, value);
                              return value;
                            })?.apply(null, [actionArgs]);
                          })()
                        : undefined;
                      if (
                        $steps["updateAmount"] != null &&
                        typeof $steps["updateAmount"] === "object" &&
                        typeof $steps["updateAmount"].then === "function"
                      ) {
                        $steps["updateAmount"] = await $steps["updateAmount"];
                      }
                    }).apply(null, eventArgs);
                  }}
                  value={generateStateValueProp($state, ["slider", "value"])}
                />
              </div>
              <LGCTAButton
                amount={$state.amount}
                buttonSlot={
                  <ButtonPrimary
                    className={classNames(
                      "__wab_instance",
                      sty.buttonPrimary__d6JGk
                    )}
                    label={
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__k5MQr
                        )}
                      >
                        {"Z\u00edskat pen\u00edze"}
                      </div>
                    }
                  />
                }
                className={classNames(
                  "__wab_instance",
                  sty.lgctaButton___0SKe0
                )}
              />

              <div className={classNames("all", "__wab_text", sty.text__nyAaZ)}>
                <React.Fragment>
                  <span
                    className={
                      "plasmic_default__all plasmic_default__span plasmic_default__span__frLTK"
                    }
                    style={{ fontWeight: 700 }}
                  >
                    {"Reprezentativn\u00ed p\u0159\u00edklad:"}
                  </span>
                  <React.Fragment>
                    {
                      "\nIde\u00e1ln\u00ed p\u016fj\u010dka na\u0161ich z\u00e1kazn\u00edk\u016f je 20 000 K\u010d v d\u00e9lce od 3 do 36 m\u011bs\u00edc\u016f, s \u00farokem 2,99% p. a., Max. RPSN 4,39%. M\u011bs\u00ed\u010dn\u00ed spl\u00e1tka 594 K\u010d. Celkem k zaplacen\u00ed 24 967 K\u010d. V\u00fdpo\u010det je pouze ilustrativn\u00ed, kone\u010dn\u00fd \u00farok ur\u010d\u00ed poskytovatel."
                    }
                  </React.Fragment>
                </React.Fragment>
              </div>
            </div>
            <PlasmicImg__
              alt={""}
              className={classNames(sty.img__uOJc)}
              displayHeight={"261px"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"auto"}
              loading={"lazy"}
              quality={100}
              src={{
                src: "/plasmic/fb_rerum/images/rerumHpDogPng.png",
                fullWidth: 479,
                fullHeight: 392,
                aspectRatio: undefined
              }}
            />
          </div>
          <div className={classNames("all", sty.freeBox___9D6L3)}>
            <h2
              className={classNames(
                "all",
                "h2",
                "h2__frLTK",
                "__wab_text",
                sty.h2__mcFu8
              )}
            >
              {"Nebankovn\u00ed p\u016fj\u010dka s v\u00fdhodami pro v\u00e1s:"}
            </h2>
          </div>
          <div
            data-plasmic-name={"whyRerum"}
            data-plasmic-override={overrides.whyRerum}
            className={classNames("all", sty.whyRerum)}
          >
            <div className={classNames("all", sty.column__g7L31)}>
              <WhyRerum
                className={classNames("__wab_instance", sty.whyRerum__i99YP)}
                slot={
                  "Vypln\u011bn\u00ed \u017e\u00e1dosti nebylo nikdy jednodu\u0161\u0161\u00ed. Na\u0161i p\u016fj\u010dku Rerum m\u016f\u017eete z\u00edskat na p\u00e1r kliknut\u00ed z pohodl\u00ed va\u0161eho domova. V\u0161e o tom, jak \u017e\u00e1dost vyplnit, najdete zde: Poradna"
                }
              >
                <div
                  className={classNames("all", "__wab_text", sty.text__ap2J)}
                >
                  {"Vypl\u0148te \u017e\u00e1dost snadno a rychle"}
                </div>
              </WhyRerum>
            </div>
            <div className={classNames("all", sty.column__mQtMc)}>
              <WhyRerum
                className={classNames("__wab_instance", sty.whyRerum__bfiei)}
                slot={
                  "\u017d\u00e1dost o p\u016fj\u010dku Rerum vy\u0159\u00edd\u00edte kompletn\u011b online. Nemus\u00edte nikam chodit ani ztr\u00e1cet \u010das."
                }
                slot2={
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__g3Y5B)}
                    displayHeight={"auto"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"35%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loading={"lazy"}
                    quality={100}
                    src={{
                      src: "/plasmic/fb_rerum/images/_2ndIconPng.png",
                      fullWidth: 400,
                      fullHeight: 458,
                      aspectRatio: undefined
                    }}
                  />
                }
              >
                {"Vy\u0159\u00edzen\u00ed p\u016fj\u010dky online"}
              </WhyRerum>
            </div>
            <div className={classNames("all", sty.column__p3MwJ)}>
              <WhyRerum
                className={classNames("__wab_instance", sty.whyRerum__dneXi)}
                slot={
                  "P\u0159ekvapily v\u00e1s ne\u010dekan\u00e9 v\u00fddaje? M\u00e1me pro V\u00e1s \u0159e\u0161en\u00ed! D\u00edky nebankovn\u00ed p\u016fj\u010dce Rerum m\u016f\u017eete z\u00edskat a\u017e 30 000 K\u010d u\u017e do 15 minut od schv\u00e1len\u00ed \u017e\u00e1dosti."
                }
                slot2={
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__ivAoc)}
                    displayHeight={"auto"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"35%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loading={"lazy"}
                    quality={100}
                    src={{
                      src: "/plasmic/fb_rerum/images/_3rdIconPng.png",
                      fullWidth: 400,
                      fullHeight: 458,
                      aspectRatio: undefined
                    }}
                  />
                }
              >
                {"Pen\u00edze na \u00fa\u010dtu do 15 minut"}
              </WhyRerum>
            </div>
          </div>
          <div className={classNames("all", sty.freeBox__rHqQm)}>
            <LGCTAButton
              amount={$state.amount}
              buttonSlot={
                <ButtonPrimary
                  className={classNames(
                    "__wab_instance",
                    sty.buttonPrimary__o9DsS
                  )}
                  label={
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__dcO90
                      )}
                    >
                      {"Chci p\u016fj\u010dku"}
                    </div>
                  }
                />
              }
              className={classNames("__wab_instance", sty.lgctaButton__nUsF)}
              id={"cta-btn-3"}
            />
          </div>
          <section className={classNames("all", sty.section__eOdD1)}>
            <div
              data-plasmic-name={"procRerum"}
              data-plasmic-override={overrides.procRerum}
              className={classNames("all", sty.procRerum)}
            >
              <h3
                data-plasmic-name={"h3"}
                data-plasmic-override={overrides.h3}
                className={classNames(
                  "all",
                  "h3",
                  "h3__frLTK",
                  "__wab_text",
                  sty.h3
                )}
                id={"opujcce"}
              >
                {"Pro\u010d si vybrat na\u0161i p\u016fj\u010dku"}
              </h3>
              <div className={classNames("all", sty.freeBox__tOmlP)}>
                <div className={classNames("all", sty.freeBox___29D9L)}>
                  <Card
                    className={classNames("__wab_instance", sty.card__aDtb7)}
                    text={
                      "Po\u017e\u00e1dejte si o na\u0161i online p\u016fj\u010dku v libovoln\u00e9 v\u00fd\u0161i a\u017e do 30 000 K\u010d."
                    }
                    title={
                      "P\u016fj\u010dka a\u017e 30 000 K\u010d pro ka\u017ed\u00e9ho"
                    }
                  />
                </div>
                <div className={classNames("all", sty.freeBox__sP81P)}>
                  <Card
                    className={classNames("__wab_instance", sty.card__aXph)}
                    text={
                      "Rerum p\u016fj\u010dka online je ur\u010dena ka\u017ed\u00e9mu, kdo dos\u00e1hl v\u011bku 18 let."
                    }
                    title={"Ka\u017ed\u00e9mu ve v\u011bku od 18 let"}
                  />
                </div>
                <div className={classNames("all", sty.freeBox__u1Tm4)}>
                  <Card
                    className={classNames("__wab_instance", sty.card__wtk19)}
                    text={
                      "Pokud v\u00e1s zasko\u010d\u00ed ne\u010dekan\u00e9 v\u00fddaje, nemus\u00edte hned sni\u017eovat sv\u016fj \u017eivotn\u00ed standard. Online p\u016fj\u010dku si vy\u0159\u00edd\u00edte na p\u00e1r kliknut\u00ed."
                    }
                    title={
                      "Pom\u016f\u017ee, kdy\u017e p\u0159ijdou ne\u010dekan\u00e9 v\u00fddaje"
                    }
                  />
                </div>
                <div className={classNames("all", sty.freeBox__l0Jo)}>
                  <Card
                    className={classNames("__wab_instance", sty.card___6NUtr)}
                    text={
                      "Rerum p\u016fj\u010dku z\u00edsk\u00e1te pohodln\u011b online, bez ru\u010ditele i bez z\u00e1stavy nemovitosti."
                    }
                    title={"Bez ru\u010ditele a z\u00e1stavy"}
                  />
                </div>
                <div className={classNames("all", sty.freeBox__kjnLc)}>
                  <Card
                    className={classNames("__wab_instance", sty.card__cktJv)}
                    text={
                      "Rerum p\u016fj\u010dku p\u0159es internet vy\u0159\u00edd\u00edte b\u011bhem chvilky a pen\u00edze m\u016f\u017eete m\u00edt na \u00fa\u010dtu je\u0161t\u011b dnes."
                    }
                    title={
                      "Pen\u00edze m\u016f\u017eete m\u00edt na \u00fa\u010dtu je\u0161t\u011b dnes"
                    }
                  />
                </div>
                <div className={classNames("all", sty.freeBox__uOxWo)}>
                  <Card
                    className={classNames("__wab_instance", sty.card___1FGk4)}
                    text={
                      "Kdy\u017e to nevyjde u n\u00e1s, pom\u016f\u017eeme v\u00e1m naj\u00edt \u0159e\u0161en\u00ed u na\u0161ich spolehliv\u00fdch partner\u016f. V\u00fdsledek se dozv\u00edte b\u011bhem p\u00e1r minut."
                    }
                    title={"M\u00e1me pl\u00e1n B"}
                  />
                </div>
              </div>
            </div>
          </section>
          <div
            data-plasmic-name={"reviewsSection"}
            data-plasmic-override={overrides.reviewsSection}
            className={classNames("all", sty.reviewsSection)}
            id={"recenze"}
          >
            <div className={classNames("all", sty.freeBox__kr0Wn)}>
              <div className={classNames("all", sty.freeBox__pd2J1)}>
                <div className={classNames("all", sty.freeBox__yQzPe)}>
                  <div className={classNames("all", sty.columns__enOqw)}>
                    <div className={classNames("all", sty.column__zlcq0)} />

                    <div className={classNames("all", sty.column__w2MkW)}>
                      <h2
                        className={classNames(
                          "all",
                          "h2",
                          "h2__frLTK",
                          "__wab_text",
                          sty.h2__j1V5
                        )}
                      >
                        {"Hodnocen\u00ed z\u00e1kazn\u00edk\u016f"}
                      </h2>
                    </div>
                    <div className={classNames("all", sty.column___0Fooe)}>
                      <div className={classNames("all", sty.freeBox__jDp4M)}>
                        <CarouselBtn
                          back={true}
                          className={classNames(
                            "__wab_instance",
                            sty.carouselBtn__o7FdC
                          )}
                          disabled={(() => {
                            try {
                              return $state.sliderCarousel.currentSlide === 0;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return false;
                              }
                              throw e;
                            }
                          })()}
                          onClick={async () => {
                            const $steps = {};

                            $steps["updateSliderCarouselCurrentSlide"] = true
                              ? (() => {
                                  const actionArgs = {
                                    variable: {
                                      objRoot: $state,
                                      variablePath: [
                                        "sliderCarousel",
                                        "currentSlide"
                                      ]
                                    },
                                    operation: 3
                                  };
                                  return (({
                                    variable,
                                    value,
                                    startIndex,
                                    deleteCount
                                  }) => {
                                    if (!variable) {
                                      return;
                                    }
                                    const { objRoot, variablePath } = variable;

                                    const oldValue = $stateGet(
                                      objRoot,
                                      variablePath
                                    );
                                    $stateSet(
                                      objRoot,
                                      variablePath,
                                      oldValue - 1
                                    );
                                    return oldValue - 1;
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["updateSliderCarouselCurrentSlide"] !=
                                null &&
                              typeof $steps[
                                "updateSliderCarouselCurrentSlide"
                              ] === "object" &&
                              typeof $steps["updateSliderCarouselCurrentSlide"]
                                .then === "function"
                            ) {
                              $steps["updateSliderCarouselCurrentSlide"] =
                                await $steps[
                                  "updateSliderCarouselCurrentSlide"
                                ];
                            }
                          }}
                        />

                        <CarouselBtn
                          className={classNames(
                            "__wab_instance",
                            sty.carouselBtn__oOqYf
                          )}
                          disabled={(() => {
                            try {
                              return $state.sliderCarousel.currentSlide === 3;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return true;
                              }
                              throw e;
                            }
                          })()}
                          onClick={async () => {
                            const $steps = {};

                            $steps["updateSliderCarouselCurrentSlide"] = true
                              ? (() => {
                                  const actionArgs = {
                                    variable: {
                                      objRoot: $state,
                                      variablePath: [
                                        "sliderCarousel",
                                        "currentSlide"
                                      ]
                                    },
                                    operation: 2
                                  };
                                  return (({
                                    variable,
                                    value,
                                    startIndex,
                                    deleteCount
                                  }) => {
                                    if (!variable) {
                                      return;
                                    }
                                    const { objRoot, variablePath } = variable;

                                    const oldValue = $stateGet(
                                      objRoot,
                                      variablePath
                                    );
                                    $stateSet(
                                      objRoot,
                                      variablePath,
                                      oldValue + 1
                                    );
                                    return oldValue + 1;
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["updateSliderCarouselCurrentSlide"] !=
                                null &&
                              typeof $steps[
                                "updateSliderCarouselCurrentSlide"
                              ] === "object" &&
                              typeof $steps["updateSliderCarouselCurrentSlide"]
                                .then === "function"
                            ) {
                              $steps["updateSliderCarouselCurrentSlide"] =
                                await $steps[
                                  "updateSliderCarouselCurrentSlide"
                                ];
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {(() => {
                  const child$Props = {
                    adaptiveHeight: true,
                    arrows: false,
                    beforeChange: async (...eventArgs: any) => {
                      generateStateOnChangePropForCodeComponents(
                        $state,
                        "currentSlide",
                        ["sliderCarousel", "currentSlide"],
                        SliderWrapper_Helpers
                      ).apply(null, eventArgs);
                    },
                    className: classNames("__wab_instance", sty.sliderCarousel),
                    dots: true,
                    infinite: false,
                    initialSlide: generateStateValueProp($state, [
                      "sliderCarousel",
                      "currentSlide"
                    ]),
                    ref: ref => {
                      $refs["sliderCarousel"] = ref;
                    },
                    rows: 1,
                    sliderScopeClassName: sty["sliderCarousel__slider"],
                    slidesPerRow: 1,
                    slidesToShow: hasVariant(
                      globalVariants,
                      "screen",
                      "mobileOnly"
                    )
                      ? 1
                      : 3,
                    speed: 300,
                    swipeToSlide: true
                  };
                  initializeCodeComponentStates(
                    $state,
                    [
                      {
                        name: "currentSlide",
                        plasmicStateName: "sliderCarousel.currentSlide"
                      }
                    ],
                    [],
                    SliderWrapper_Helpers ?? {},
                    child$Props
                  );

                  return (
                    <SliderWrapper
                      data-plasmic-name={"sliderCarousel"}
                      data-plasmic-override={overrides.sliderCarousel}
                      {...child$Props}
                    >
                      <div className={classNames("all", sty.freeBox__joVAb)}>
                        <ReviewCard
                          avatar={
                            "https://res.cloudinary.com/dcilmscri/image/upload/q_auto/f_auto/v1776812734/Petra_P._51_let_zzuvb4.png"
                          }
                          className={classNames(
                            "__wab_instance",
                            sty.reviewCard__rovW
                          )}
                          name={"Petra P., 51 let"}
                          text={
                            "Nejv\u00edc oce\u0148uju, \u017ee se v\u0161echno \u0159e\u0161\u00ed z gau\u010de. Nemusela jsem nikam b\u011bhat ani n\u011bco tisknout. V\u0161echno jasn\u00e9, rychl\u00e9 a bez stresu."
                          }
                        />
                      </div>
                      <div className={classNames("all", sty.freeBox__gtL2Q)}>
                        <ReviewCard
                          avatar={
                            "https://res.cloudinary.com/dcilmscri/image/upload/q_auto/f_auto/v1776812647/Jir%CC%8Ci%CC%81_D._58_let_o7kuea.png"
                          }
                          className={classNames(
                            "__wab_instance",
                            sty.reviewCard___4ZzZn
                          )}
                          name={"Ji\u0159\u00ed D., 58 let"}
                          text={
                            "Pot\u0159eboval jsem men\u0161\u00ed \u010d\u00e1stku na opravu auta a \u0161lo to fakt hladce. \u017d\u00e1dn\u00e9 zdr\u017eov\u00e1n\u00ed, v\u0161echno p\u0159ehledn\u00e9 a komunikace \u00fapln\u011b v pohod\u011b. Doporu\u010duju."
                          }
                        />
                      </div>
                      <div className={classNames("all", sty.freeBox__xoc9L)}>
                        <ReviewCard
                          avatar={
                            "https://res.cloudinary.com/dcilmscri/image/upload/q_auto/f_auto/v1776812736/Radek_S%CC%8C._29_let_emw3fz.png"
                          }
                          className={classNames(
                            "__wab_instance",
                            sty.reviewCard__muj0
                          )}
                          name={"Radek \u0160., 29 let"}
                          text={
                            "V bance mi necht\u011bli pomoct s men\u0161\u00edm \u00fav\u011brem, tady to \u0161lo bez zbyte\u010dn\u00fdch pr\u016ftah\u016f. Poslal jsem \u017e\u00e1dost dopoledne a je\u0161t\u011b ten den byly pen\u00edze na \u00fa\u010dtu. Par\u00e1da."
                          }
                        />
                      </div>
                      <div className={classNames("all", sty.freeBox___0Bhpt)}>
                        <ReviewCard
                          avatar={
                            "https://res.cloudinary.com/dcilmscri/image/upload/q_auto/f_auto/v1776812738/Lucie_K._24_swjdbs.png"
                          }
                          className={classNames(
                            "__wab_instance",
                            sty.reviewCard__ugik3
                          )}
                          name={"Lucie K., 24 let"}
                          text={
                            "Vy\u0159izovala jsem to ve\u010der po pr\u00e1ci a bylo to \u00fapln\u011b v pohod\u011b. V\u0161echno online, \u017e\u00e1dn\u00e9 pap\u00edry ani vol\u00e1n\u00ed. Po schv\u00e1len\u00ed to \u0161lo rychle, super jednoduch\u00fd proces."
                          }
                        />
                      </div>
                      <div className={classNames("all", sty.freeBox__r7Sdi)}>
                        <ReviewCard
                          avatar={
                            "https://res.cloudinary.com/dcilmscri/image/upload/q_auto/f_auto/v1776812736/Milan_B._36_let_lvezlt.png"
                          }
                          className={classNames(
                            "__wab_instance",
                            sty.reviewCard___5VXx
                          )}
                          name={"Milan B., 36 let"}
                          text={
                            "Podal jsem \u017e\u00e1dost online a b\u011bhem chvilky bylo hotovo. \u017d\u00e1dn\u00e9 zbyte\u010dnosti, \u017e\u00e1dn\u00e9 triky."
                          }
                        />
                      </div>
                      <div className={classNames("all", sty.freeBox__hdyp0)}>
                        <ReviewCard
                          avatar={
                            "https://res.cloudinary.com/dcilmscri/image/upload/q_auto/f_auto/v1776812734/S%CC%8Ca%CC%81rka_N._62_let_ms2jcr.png"
                          }
                          className={classNames(
                            "__wab_instance",
                            sty.reviewCard__lQxvG
                          )}
                          name={"\u0160\u00e1rka N., 62 let"}
                          text={
                            "Vy\u0159izovala jsem to ve\u010der po pr\u00e1ci a bylo to \u00fapln\u011b v pohod\u011b. V\u0161echno online, \u017e\u00e1dn\u00e9 pap\u00edry ani vol\u00e1n\u00ed. Po schv\u00e1len\u00ed to \u0161lo rychle, super jednoduch\u00fd proces."
                          }
                        />
                      </div>
                    </SliderWrapper>
                  );
                })()}
              </div>
            </div>
          </div>
          <section
            data-plasmic-name={"faq"}
            data-plasmic-override={overrides.faq}
            className={classNames("all", sty.faq)}
          >
            <h1
              className={classNames(
                "all",
                "h1",
                "h1__frLTK",
                "__wab_text",
                sty.h1__aCtaQ
              )}
              id={"faq"}
            >
              {"\u010cast\u00e9 dotazy k p\u016fj\u010dk\u00e1m"}
            </h1>
            <FaqItem
              className={classNames("__wab_instance", sty.faqItem__ybDVa)}
            />

            <FaqItem
              className={classNames("__wab_instance", sty.faqItem___73PT)}
              slot={
                "P\u016fj\u010dku m\u016f\u017ee z\u00edskat ka\u017ed\u00fd, kdo m\u00e1 trval\u00fd pobyt v \u010cesk\u00e9 republice, je star\u0161\u00ed 18 let a m\u00e1 vlastn\u00ed bankovn\u00ed \u00fa\u010det, kam m\u016f\u017eeme pen\u00edze poslat. D\u016fle\u017eit\u00e9 je m\u00edt tak\u00e9 pravideln\u00fd p\u0159\u00edjem a b\u00fdt schopn\u00fd p\u016fj\u010dku \u0159\u00e1dn\u011b spl\u00e1cet. Horn\u00ed v\u011bkov\u00e1 hranice je 75 let."
              }
            >
              {
                "Co mus\u00edm spl\u0148ovat pro z\u00edsk\u00e1n\u00ed p\u016fj\u010dky?"
              }
            </FaqItem>
            <FaqItem
              className={classNames("__wab_instance", sty.faqItem__uh57B)}
              slot={
                "Ne, samotn\u00e9 vy\u0159\u00edzen\u00ed p\u016fj\u010dky je zcela zdarma. Ne\u00fa\u010dtujeme \u017e\u00e1dn\u00e9 skryt\u00e9 poplatky ani n\u00e1klady za pod\u00e1n\u00ed \u017e\u00e1dosti \u010di schv\u00e1len\u00ed. V\u0161echny podm\u00ednky zn\u00e1te dop\u0159edu \u2013 bez p\u0159ekvapen\u00ed. P\u0159\u00edpadn\u00e9 poplatky se mohou t\u00fdkat jen dopl\u0148kov\u00fdch slu\u017eeb, jako je veden\u00ed \u00fav\u011bru, prodlou\u017een\u00ed splatnosti nebo jin\u00e9 slu\u017eby, kter\u00e9 si dobrovoln\u011b zvol\u00edte. V\u017edy jsou jasn\u011b uveden\u00e9 ve smlouv\u011b."
              }
            >
              {
                "Plat\u00ed se n\u011bco za vy\u0159\u00edzen\u00ed p\u016fj\u010dky?"
              }
            </FaqItem>
            <FaqItem
              className={classNames("__wab_instance", sty.faqItem__eNui)}
              slot={
                "K vy\u0159\u00edzen\u00ed p\u016fj\u010dky pot\u0159ebujeme jen p\u00e1r z\u00e1kladn\u00edch doklad\u016f, abychom mohli ov\u011b\u0159it va\u0161i toto\u017enost a p\u0159\u00edjem:\n- platn\u00fd ob\u010dansk\u00fd pr\u016fkaz,\n- druh\u00fd doklad toto\u017enosti (nap\u0159. \u0159idi\u010dsk\u00fd pr\u016fkaz nebo pas),\n- v\u00fdplatn\u00ed p\u00e1sky nebo v\u00fdpisy z \u00fa\u010dtu za posledn\u00ed 3 m\u011bs\u00edce, kter\u00e9 potvrzuj\u00ed pravideln\u00fd p\u0159\u00edjem."
              }
            >
              {
                "Jak\u00e9 doklady pot\u0159ebuji k vy\u0159\u00edzen\u00ed p\u016fj\u010dky?"
              }
            </FaqItem>
            <FaqItem
              className={classNames("__wab_instance", sty.faqItem__zSqbo)}
            >
              {
                "Jak\u00e9 doklady mus\u00edm p\u0159edlo\u017eit, abych z\u00edskal/a p\u016fj\u010dku?"
              }
            </FaqItem>
            <FaqItem
              className={classNames("__wab_instance", sty.faqItem__mzlT8)}
              slot={
                "Ve v\u011bt\u0161in\u011b p\u0159\u00edpad\u016f ano. Pokud ale p\u0159i posouzen\u00ed zjist\u00edme, \u017ee spole\u010dnost Rerum v\u00e1m p\u016fj\u010dku poskytnout nem\u016f\u017ee, automaticky ov\u011b\u0159\u00edme mo\u017enosti u ov\u011b\u0159en\u00fdch partner\u016f. V\u00fdsledek se dozv\u00edte do jedn\u00e9 minuty. Z\u00e1le\u017e\u00ed n\u00e1m na tom, abyste i v n\u00e1ro\u010dn\u00e9 situaci m\u011bli p\u0159\u00edstup k prost\u0159edk\u016fm, kter\u00e9 pot\u0159ebujete."
              }
            >
              {
                "Dostanu p\u016fj\u010dku p\u0159\u00edmo od va\u0161\u00ed spole\u010dnosti?"
              }
            </FaqItem>
          </section>
          <section className={classNames("all", sty.section__j6CNl)}>
            <div className={classNames("all", sty.columns__b4Z7V)}>
              <div className={classNames("all", sty.column___65Icd)}>
                <div className={classNames("all", sty.freeBox___9M2Ge)}>
                  <h2
                    className={classNames(
                      "all",
                      "h2",
                      "h2__frLTK",
                      "__wab_text",
                      sty.h2__vR6O
                    )}
                  >
                    {"Jdeme na to?"}
                  </h2>
                  <div
                    className={classNames("all", "__wab_text", sty.text__xrfUg)}
                  >
                    {
                      "Jednoduchou \u017e\u00e1dost vypln\u00edte za p\u00e1r minut!"
                    }
                  </div>
                </div>
              </div>
              <div className={classNames("all", sty.column__tJ8Fl)}>
                <div className={classNames("all", sty.freeBox__rEfCt)}>
                  <h4
                    data-plasmic-name={"h4"}
                    data-plasmic-override={overrides.h4}
                    className={classNames(
                      "all",
                      "h4",
                      "h4__frLTK",
                      "__wab_text",
                      sty.h4
                    )}
                  >
                    <React.Fragment>
                      <span
                        className={
                          "plasmic_default__all plasmic_default__span plasmic_default__span__frLTK"
                        }
                        style={{ color: "var(--token-4ERGO4zCUti6)" }}
                      >
                        {"Za\u010dn\u011bte v\u00fdb\u011brem \u010d\u00e1stky"}
                      </span>
                    </React.Fragment>
                  </h4>
                  <Slider
                    data-plasmic-name={"slider2"}
                    data-plasmic-override={overrides.slider2}
                    className={classNames("__wab_instance", sty.slider2)}
                    footerSlider={"footerSlider"}
                    label={
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__ddqE
                        )}
                      >
                        {"Zvolte \u010d\u00e1stku"}
                      </div>
                    }
                    onChange={async (...eventArgs: any) => {
                      generateStateOnChangeProp($state, [
                        "slider2",
                        "value"
                      ]).apply(null, eventArgs);

                      if (
                        eventArgs.length > 1 &&
                        eventArgs[1] &&
                        eventArgs[1]._plasmic_state_init_
                      ) {
                        return;
                      }

                      (async val => {
                        const $steps = {};

                        $steps["updateAmount"] = true
                          ? (() => {
                              const actionArgs = {
                                variable: {
                                  objRoot: $state,
                                  variablePath: ["amount"]
                                },
                                operation: 0,
                                value: $state.slider2.value
                              };
                              return (({
                                variable,
                                value,
                                startIndex,
                                deleteCount
                              }) => {
                                if (!variable) {
                                  return;
                                }
                                const { objRoot, variablePath } = variable;

                                $stateSet(objRoot, variablePath, value);
                                return value;
                              })?.apply(null, [actionArgs]);
                            })()
                          : undefined;
                        if (
                          $steps["updateAmount"] != null &&
                          typeof $steps["updateAmount"] === "object" &&
                          typeof $steps["updateAmount"].then === "function"
                        ) {
                          $steps["updateAmount"] = await $steps["updateAmount"];
                        }
                      }).apply(null, eventArgs);
                    }}
                    value={generateStateValueProp($state, ["slider2", "value"])}
                  />

                  <LGCTAButton
                    amount={$state.amount}
                    buttonSlot={
                      <ButtonPrimary
                        className={classNames(
                          "__wab_instance",
                          sty.buttonPrimary__iMBt
                        )}
                        label={
                          <div
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.text___69WUj
                            )}
                          >
                            {"Z\u00edskat p\u016fj\u010dku"}
                          </div>
                        }
                        type={"bordered"}
                      />
                    }
                    className={classNames(
                      "__wab_instance",
                      sty.lgctaButton__kGkY
                    )}
                    id={"cta-btn-4"}
                  />
                </div>
              </div>
            </div>
          </section>
          <FooterSection
            data-plasmic-name={"footerSection"}
            data-plasmic-override={overrides.footerSection}
            className={classNames("__wab_instance", sty.footerSection)}
          />
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  homePageWrapper: [
    "homePageWrapper",
    "lgPresetMessage",
    "headerHeroSection",
    "menuButton",
    "menuCloseButton",
    "crossSvg",
    "mobileMenu",
    "pageWrapper",
    "slider",
    "whyRerum",
    "procRerum",
    "h3",
    "reviewsSection",
    "sliderCarousel",
    "faq",
    "h4",
    "slider2",
    "footerSection"
  ],
  lgPresetMessage: ["lgPresetMessage"],
  headerHeroSection: [
    "headerHeroSection",
    "menuButton",
    "menuCloseButton",
    "crossSvg"
  ],
  menuButton: ["menuButton"],
  menuCloseButton: ["menuCloseButton", "crossSvg"],
  crossSvg: ["crossSvg"],
  mobileMenu: ["mobileMenu"],
  pageWrapper: ["pageWrapper", "slider"],
  slider: ["slider"],
  whyRerum: ["whyRerum"],
  procRerum: ["procRerum", "h3"],
  h3: ["h3"],
  reviewsSection: ["reviewsSection", "sliderCarousel"],
  sliderCarousel: ["sliderCarousel"],
  faq: ["faq"],
  h4: ["h4"],
  slider2: ["slider2"],
  footerSection: ["footerSection"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  homePageWrapper: "div";
  lgPresetMessage: typeof LGPresetMessage;
  headerHeroSection: "div";
  menuButton: "button";
  menuCloseButton: "button";
  crossSvg: "svg";
  mobileMenu: "div";
  pageWrapper: "div";
  slider: typeof Slider;
  whyRerum: "div";
  procRerum: "div";
  h3: "h3";
  reviewsSection: "div";
  sliderCarousel: typeof SliderWrapper;
  faq: "section";
  h4: "h4";
  slider2: typeof Slider;
  footerSection: typeof FooterSection;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomepage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomepage__VariantsArgs;
    args?: PlasmicHomepage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicHomepage__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHomepage__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomepage__ArgProps,
          internalVariantPropNames: PlasmicHomepage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "homePageWrapper") {
    func.displayName = "PlasmicHomepage";
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("homePageWrapper"),
  {
    // Helper components rendering sub-elements
    lgPresetMessage: makeNodeComponent("lgPresetMessage"),
    headerHeroSection: makeNodeComponent("headerHeroSection"),
    menuButton: makeNodeComponent("menuButton"),
    menuCloseButton: makeNodeComponent("menuCloseButton"),
    crossSvg: makeNodeComponent("crossSvg"),
    mobileMenu: makeNodeComponent("mobileMenu"),
    pageWrapper: makeNodeComponent("pageWrapper"),
    slider: makeNodeComponent("slider"),
    whyRerum: makeNodeComponent("whyRerum"),
    procRerum: makeNodeComponent("procRerum"),
    h3: makeNodeComponent("h3"),
    reviewsSection: makeNodeComponent("reviewsSection"),
    sliderCarousel: makeNodeComponent("sliderCarousel"),
    faq: makeNodeComponent("faq"),
    h4: makeNodeComponent("h4"),
    slider2: makeNodeComponent("slider2"),
    footerSection: makeNodeComponent("footerSection"),

    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps,

    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/",
      pagePath: "/",
      params: {},
      query: {}
    })
  }
);

export default PlasmicHomepage;
/* prettier-ignore-end */
